import { ResetFiltersButton } from "@/controls/buttons/ResetFiltersButton";
import { Box, Checkbox, FormControlLabel } from "@mui/material";
import { Moment } from "moment";
import { FC, useEffect, useState } from "react";
import {
	EndFilter,
	StartFilter,
} from "../../../shared/components/StartEndFilter";

type Props = {
	onFilterChange: (startDate: Moment, endDate: Moment) => void;
	initialStartDate: Moment;
	initialEndDate: Moment;
	selectedDelayArea: number | null;
	onDelayAreaChange: (assetId: number | null) => void;
	includeUndeclaredDelays: boolean;
	onIncludeUndeclaredDelaysChange: (include: boolean) => void;
	onReset: () => void;
	canReset: boolean;
};

export const Filters: FC<Props> = ({
	onFilterChange,
	initialStartDate,
	initialEndDate,
	selectedDelayArea,
	onDelayAreaChange,
	includeUndeclaredDelays,
	onIncludeUndeclaredDelaysChange,
	onReset,
	canReset,
}) => {
	const [startDate, setStartDate] = useState<Moment>(initialStartDate);
	const [endDate, setEndDate] = useState<Moment>(initialEndDate);

	useEffect(() => {
		setStartDate(initialStartDate);
		setEndDate(initialEndDate);
	}, [initialStartDate, initialEndDate]);

	const handleStartDateChange = (date: Moment | null) => {
		if (date) {
			setStartDate(date);
			onFilterChange(date, endDate);
		}
	};

	const handleEndDateChange = (date: Moment | null) => {
		if (date) {
			setEndDate(date);
			onFilterChange(startDate, date);
		}
	};

	return (
		<Box
			sx={{
				display: "flex",
				alignItems: "center",
				gap: 1,
				px: 1.5,
				py: 0.75,
				flexWrap: "wrap",
			}}
		>
			<Box sx={{ minWidth: 150, maxWidth: 170 }}>
				<StartFilter
					value={startDate}
					onChange={handleStartDateChange}
					maxDate={endDate}
				/>
			</Box>
			<Box sx={{ minWidth: 150, maxWidth: 170 }}>
				<EndFilter
					value={endDate}
					onChange={handleEndDateChange}
					minDate={startDate}
				/>
			</Box>
			{/* <Grid2 size={{xs:12}} size={{md: 2}}>
        <DelayAreaFilter
          value={selectedDelayArea}
          onChange={onDelayAreaChange}
        />
      </Grid2> */}
			<FormControlLabel
				sx={{ mr: 0 }}
				control={
					<Checkbox
						checked={includeUndeclaredDelays}
						color="primary"
						onChange={(e) => onIncludeUndeclaredDelaysChange(e.target.checked)}
					/>
				}
				label="Undeclared"
			/>
			<ResetFiltersButton onClick={onReset} disabled={!canReset} />
		</Box>
	);
};
